import Image from 'next/image';
import productImageLoader from '@/lib/product-image-loader';
import type { FC } from 'react';
// import imageLoader from '@/lib/image-loader';

export type ImageGalleryProps = {
  images: {
    alt: string;
    height?: number | null;
    name: string;
    src: string;
    width?: number | null;
  }[];
};

const ImageGallery: FC<ImageGalleryProps> = ({ images }) => {
  return (
    <div className='flex flex-col-reverse'>
      <div className='aspect-w-1 aspect-h-1 w-full'>
        {images.map((image, idx) => (
          <div key={`product-gallery-large-panel-${idx}`} className='h-full w-full rounded-lg'>
            {image.src && (
              <Image
                alt={image.alt ?? ''}
                className='h-full w-full rounded-lg object-contain object-center'
                fill={!(image.height && image.width)}
                height={image.width && image.height ? image.height : undefined}
                loader={productImageLoader}
                src={image.src}
                unoptimized
                width={image.height && image.width ? image.width : undefined}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

ImageGallery.displayName = 'ImageGallery';

export default ImageGallery;
